import React, {
  useState,
  createContext,
  useEffect,
  useContext,
  useMemo,
} from "react";

import { useQuery, gql } from "@apollo/client";

import UserContext, { User } from "./contexts/user";
import EventContext from "./contexts/event";

import { IntlProvider } from "react-intl";

import LivePresentationsSubscription from "./helpers/live-presentations-subscription";
import { PreLoader } from "./components/preloader";
import UserAuth from "./containers/user-auth";
import Routes from "./routes";

import translations from "./i18n/locales";

import './index.css';
import "./App.scss";

import "sweetalert2/src/sweetalert2.scss";
import { transitions, positions, Provider as AlertProvider } from "react-alert";
// import AlertTemplate from 'react-alert-template-basic'
import ResetPassword from "./components/auth/reset-password";
import io from "socket.io-client";


// export const AuthContext = createContext({
//   resettoken: "",
//   setResetToken: (s: string) => {},

// });

function App({ socket }: { socket: any }) {
  const userContext = useContext(UserContext);

  const [loadingUser, setLoadingUser] = useState(true);
  const slug = useMemo(() => document.location.pathname.split("/")[1], []);

  const [token, setToken] = useState(false);
  const [
    { presentationsWithQuestions, presentationsWithResults },
    setPresentationData,
  ] = useState<{
    presentationsWithQuestions: Array<string>;
    presentationsWithResults: Array<string>;
  }>({
    presentationsWithQuestions: [],
    presentationsWithResults: [],
  });

  const urlParams = new URLSearchParams(window.location.search);
  const resetToken = urlParams.get("resettoken");
  const resetCode = urlParams.get("resetcode");
  const tabParam = urlParams.get("tab");  // Diljith krishna added this , 29/01/2026

  console.log("resetcode-------------", resetCode)

  const { setUser, currentEvent, listUser, setListUser } = userContext;

  const [locale, setLocale] = useState(localStorage.getItem("locale") || "fr");

  const getMessages = () => {
    switch (locale) {
      case "fr":
        return translations.fr;
      default:
        return translations.en;
    }
  };

  const _setLocale = (locale: string) => {
    console.log(locale, "localeeeeee");

    localStorage.setItem("locale", locale);
    setLocale(locale);
    window.scrollTo(0, 0);
  };


  // Commented for unused code make web load issue :  Arun (12 Jan 2022)

  // useQuery<{ user_private: Array<User> }>(
  //     gql`
  //     query {
  //       user_private {
  //         id
  //         name
  //         email
  //         photo
  //         is_moderator
  //         is_speaker
  //         is_association
  //         disabled
  //         speaker_id
  //         picture
  //       }
  //     }
  //   `,
  //     {
  //       skip: !token,
  //       onError: (error) => {
  //          console.log('debug: query: user_private: onError', error)
  //         setUser(null);
  //         setLoadingUser(false);
  //       },
  //       onCompleted: (response) => {
  //
  //          console.log("response user private",response)
  //         if (response.user_private.length === 0) {
  //           setUser(null);
  //         }
  //
  //         setUser(response.user_private[0]);
  //         setLoadingUser(false);
  //       },
  //     }
  // );




  // assign login user to the userContext

  useEffect(() => {

    const lu = JSON.parse(listUser);
    console.log('debug: lu: ', lu);
    if (lu.id) {
      setUser(lu.user)
      setLoadingUser(false);
    }
  }, [])

  useEffect(() => {
    if (!currentEvent) {
      return;
    }

    const lu = JSON.parse(listUser);
    console.log('debug: lu: ', lu);
    if (lu.id) {
      console.log('setToken', lu);
      console.log('setToken:', lu.token)
      setToken(lu.token);

    } else {
      setUser(null);
      setLoadingUser(false);
    }
  }, [listUser, setListUser, setUser, currentEvent, setToken]);

  // let { event } = data.data;

  if (currentEvent.schedule_background_color) {
    document.documentElement.style.setProperty(
      "--primary-color",
      currentEvent.schedule_background_color
    );
    document.documentElement.style.setProperty(
      "--primary-color-trans",
      `${currentEvent.schedule_background_color}99`
    );
  }

  if (currentEvent.schedule_text_color) {
    document.documentElement.style.setProperty(
      "--primary-text-contrast-color",
      currentEvent.schedule_text_color
    );
  }

  // return <pre>{JSON.stringify(userContext)}</pre>
  // (currentEvent.quiz || currentEvent.forum) && currentEvent.displayMode === "login" &&

  // if (loadingUser) return <i>App.tsx: loadingUser</i>

  if (loadingUser) return <PreLoader />;

  let url = window.location.href;

  console.log("userContext-----", userContext);
  console.log("presentationsWithQuestions", presentationsWithQuestions);



  return (
    // <AuthContext.Provider value={{ resettoken, setResetToken }}>



    // <WinstonProvider logger={logger}>
    <EventContext.Provider
      value={{
        id: currentEvent._id,
        slug,
        forum: currentEvent.forum,
        quiz: currentEvent.quiz,
        presentationsWithQuestions,
        presentationsWithResults,
        setPresentationData,
      }}
    >
      {/* <pre>{JSON.stringify({ user: userContext.user }, null, 2)}</pre> */}
      {/*  console.log(userContext.showLogin ,userContext.user) */}

      {console.log(
        "usercontext in apptsx  ",
        userContext.oneTimeShowLogin,
        userContext
      )}



      {resetCode ? (
        <UserAuth />
      ) : resetToken ? (
        <UserAuth />
      ) : tabParam === "connexion" ? (  //Diljith krishna added this , 29/01/2026
        <UserAuth />
      ) : userContext.oneTimeShowLogin ? (
        <UserAuth />
      ) : userContext.showLogin ? (
        <UserAuth />
      ) : (
        <>
          <LivePresentationsSubscription />
          <IntlProvider locale={locale} messages={getMessages()} key={locale}>
            <Routes locale={locale} setLocale={_setLocale} socket={socket} />
          </IntlProvider>
        </>
      )}
    </EventContext.Provider>
    // {/* </WinstonProvider> */}
  );
}

export default App;
